import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { COLOR_OPTIONS } from '../../utils/colors';
import { ColorChip } from './ColorChip';

interface ColorPickerProps {
  value?: string;
  onChange: (color: string) => void;
  label?: string;
  fullWidth?: boolean;
  required?: boolean;
  disabled?: boolean;
  size?: 'small' | 'medium';
}

/**
 * Reusable ColorPicker component for selecting colors consistently across the app
 * Used in board stages, workflow statuses, and other color selection interfaces
 */
export const ColorPicker: React.FC<ColorPickerProps> = ({
  value = 'blue',
  onChange,
  label = 'Color',
  fullWidth = true,
  required = false,
  disabled = false,
  size = 'medium',
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value);
  };

  return (
    <FormControl fullWidth={fullWidth} size={size} disabled={disabled}>
      <InputLabel required={required}>{label}</InputLabel>
      <Select
        value={value}
        label={label}
        onChange={handleChange}
        renderValue={(selected) => (
          <ColorChip color={selected} size="small" showLabel={true} variant="standard" />
        )}
      >
        {COLOR_OPTIONS.map((colorOption) => (
          <MenuItem key={colorOption.value} value={colorOption.value}>
            <ColorChip
              color={colorOption.value}
              size="small"
              showLabel={true}
              variant="standard"
            />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};